module.exports = __webpack_public_path__ + "static/media/arrowUpWhite.e6371f0c.svg";